export default __webpack_public_path__ + "static/media/2011-AMcover.da34aa14.png";